
import { useInformation, useCart}  from '@/store/store.ts';

export default {
  setup(){
    const { getCart, resetCart  } = useCart();
    const { setMessage  } = useInformation()

    const clearCart = () => {
      resetCart();
      setMessage("You cleared your cart")
    }

    return {
      items: getCart,
      clearCart
    }
  }
}
